export default __webpack_public_path__ + "static/media/GPA_organizational_chart_v3.0b08299c.jpg";